import { DeliveryIcon, TakeIcon, ReturnIcon, WarningIcon, CheckCircleIcon, ClearIcon } from 'sharedComponents/Icons';

export const ORDERS_SORT_BY = [
  {
    value: 'dateDesc',
    name: 'Newest - Oldest',
    newName: 'NEWEST',
  },
  {
    value: 'dateAsc',
    name: 'Oldest - Newest',
    newName: 'OLDEST',
  },
  {
    value: 'costDesc',
    name: '$$$ - $',
  },
  {
    value: 'costAsc',
    name: '$ - $$$',
  },
];

export const ORDERS_GRID_SORT_BY = [
  {
    value: 'dateDesc',
    name: 'NEWEST',
  },
  {
    value: 'dateAsc',
    name: 'OLDEST',
  },
  {
    value: 'costItemDesc',
    name: '$$$ - $',
  },
  {
    value: 'costItemAsc',
    name: '$ - $$$',
  },
];

export const ORDERS_FILTER_BY_DATE = [
  {
    value: '1',
    name: 'Past Day',
  },
  {
    value: '7',
    name: 'Past Week',
  },
  {
    value: '30',
    name: 'Last 30 Days',
  },
  {
    value: '180',
    name: 'Last 6 Months',
  },
];

export const ORDER_PLACED_BY = {
  ME: 'Me',
  OTHER_ASSOCIATE: 'Other Associates',
  CLIENT: 'Client',
};

export const ORDER_STATUS = {
  SHIPPED: 'Shipped',
  PENDING: 'Pending',
  ISSUE: 'Issues',
  RETURNED: 'Returned',
  TAKE: 'Take',
  CANCELLED: 'Cancelled',
};

export const ORDER_BRAND = {
  BG: 'BG',
  NM: 'NM',
};
export const ORDER_BRAND_EXP = {
  ...ORDER_BRAND,
  LC: 'LC',
  HC: 'HC',
};

export const ORDER_CHANNEL = {
  inStore: 'In-store',
  online: 'Online',
  cmos: 'CMOS',
  connect: 'Connect',
};

export const ORDER_CHANNEL_EXP = {
  ...ORDER_CHANNEL,
  phone: 'Phone',
};

export const ORDERS_FILTERS_PLACED_BY = [
  { value: ORDER_PLACED_BY.CLIENT, name: 'Client' },
  { value: ORDER_PLACED_BY.ME, name: 'Me' },
  { value: ORDER_PLACED_BY.OTHER_ASSOCIATE, name: 'Other Associates' },
];

export const ORDERS_FILTERS_BRAND = [
  { value: ORDER_BRAND.NM, name: 'Neiman Marcus' },
  { value: ORDER_BRAND.BG, name: 'Bergdorf Goodman' },
  { value: ORDER_BRAND_EXP.LC, name: 'Last Call' },
  { value: ORDER_BRAND_EXP.HC, name: 'Horchow' },
];

export const brandLongToShortNamesMap = {
  'Neiman Marcus': 'NM',
  'Bergdorf Goodman': 'BG',
  'Last Call': 'LC',
  Horchow: 'HC',
};

export const ORDERS_FILTERS_CHANNEL = [
  { value: ORDER_CHANNEL.inStore, name: 'In Store' },
  { value: ORDER_CHANNEL.online, name: 'Online' },
  { value: ORDER_CHANNEL.connect, name: 'Connect' },
  { value: ORDER_CHANNEL_EXP.phone, name: 'Phone' },
];

export const ORDERS_FILTERS_STATUS = [
  { value: ORDER_STATUS.SHIPPED, name: 'Shipped' },
  { value: ORDER_STATUS.PENDING, name: 'Pending' },
  { value: ORDER_STATUS.ISSUE, name: 'Issues' },
  { value: ORDER_STATUS.RETURNED, name: 'Returned' },
  { value: ORDER_STATUS.TAKE, name: 'Take' },
  { value: ORDER_STATUS.CANCELLED, name: 'Cancelled' },
];

export const ORDERS_FILTERS_STATUS_EXP = [
  { value: ORDER_STATUS.SHIPPED, name: 'Shipped', Icon: DeliveryIcon },
  { value: ORDER_STATUS.TAKE, name: 'Take', Icon: TakeIcon },
  { value: ORDER_STATUS.RETURNED, name: 'Returned', Icon: ReturnIcon },
  { value: ORDER_STATUS.ISSUE, name: 'Issues', Icon: WarningIcon },
  { value: ORDER_STATUS.PENDING, name: 'Pending', Icon: CheckCircleIcon },
  { value: ORDER_STATUS.CANCELLED, name: 'Cancelled', Icon: ClearIcon },
];

export const ORDER_CONFIRMATION_TYPE = {
  RETURN: 'return',
  VOID: 'void',
  GIFT: 'gift',
  DEFAULT: 'default',
};

export const ORDER_SERVICES_DEPT_TYPE = {
  150: 'Alteration',
  903: 'Gift Wrap',
  995: 'Delivery fee',
  904: 'Service name',
};

export const BG_ELEVATED_PACKAGING_THRESHOLD_PRICE = 700;

export const DEFAULT_ASSOCIATE_FILTERS = {
  date: ORDERS_FILTER_BY_DATE[2].value,
  status: [],
  channel: [],
};

export const DEFAULT_CLIENT_FILTERS = {
  date: ORDERS_FILTER_BY_DATE[2].value,
  placedBy: Object.values(ORDER_PLACED_BY),
  channel: [],
  brand: [],
};
